import type { PartialOnly } from '@ipfabric/utils/types/PartialOnly';
import { z } from 'zod';
import {
  type SiteSeparationAttributeTransformation,
  siteSeparationAttributeTransformationSchemaZ,
} from './siteSeparationAttributeTransformation';
import {
  type SiteSeparationRuleCommon,
  siteSeparationRuleCommonSchemaZ,
} from './siteSeparationRuleCommon';

export const CloudVendors = ['aws', 'azure', 'gcp'] as const;
export type CloudVendor = (typeof CloudVendors)[number];

export interface SlugSiteSeparationRule extends SiteSeparationRuleCommon {
  type: 'slug';
  transformation: SiteSeparationAttributeTransformation;
  enabledVendors: CloudVendor[];
  applyToCloudInstances: boolean;
}

export type SlugSiteSeparationRequestRule = PartialOnly<
  SlugSiteSeparationRule,
  'id'
>;

export const slugSiteSeparationRuleSchemaZ = z
  .object({
    ...siteSeparationRuleCommonSchemaZ.shape,
    type: z.literal('slug'),
    transformation: siteSeparationAttributeTransformationSchemaZ,
    enabledVendors: z
      .array(z.enum(CloudVendors))
      .min(1)
      .refine((arr) => new Set(arr).size === arr.length, {
        message: 'Must be unique',
      }),
    applyToCloudInstances: z.boolean(),
  })
  .strict();

export const slugSiteSeparationRequestRuleSchemaZ = z
  .object({
    ...slugSiteSeparationRuleSchemaZ.shape,
    id: slugSiteSeparationRuleSchemaZ.shape.id.optional(),
  })
  .strict();
